module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wrapper relative"
  }, [_c('icon', {
    staticClass: "is-hoverable absolute",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2.9",
      "name": "chevron-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prev($event)
      }
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "is-hoverable absolute",
    class: {
      gray: false
    },
    attrs: {
      "scale": "2.9",
      "name": "chevron-right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }), _vm._v(" "), (_vm.slides.length) ? _c('carousel', {
    ref: "carousel",
    attrs: {
      "adjustableHeight": true,
      "per-page": 1,
      "navigationSize": 1000,
      "navigationNextLabel": ">",
      "navigationPrevLabel": "<",
      "navigation-enabled": true,
      "navigationColor": 'white',
      "paginationEnabled": false,
      "paginationColor": 'black'
    }
  }, _vm._l((_vm.slides), function(slide) {
    return _c('slide', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('hero', {
      attrs: {
        "top": true,
        "backgroundImage": ("https://" + (_vm.baseURL()) + (slide.value.path))
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7cec41e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/landing.vue
// module id = 1150
// module chunks = 1